import React from 'react'

type DiagonalLabelPropsType = {
    color: string,
    labelColor: string,
    label: string,
}

const DiagonalLabel: React.FC<DiagonalLabelPropsType> = ({ color, labelColor, label }) =>
    <svg viewBox="0 0 54 54" xmlns="http://www.w3.org/2000/svg">
        <polygon points="0,54 54,0 32,0 0,32" fill={color} stroke={color} />
        <path id="tpath" fill="none" stroke={color} d="M 11,38 L 38,11" />
        <text><textPath href="#tpath" style={{font: 'bold 13px sans-serif', fill: labelColor}}>{label}</textPath></text>
    </svg>

export default DiagonalLabel
